import { useState, useCallback } from "react";

type RecipeDialogId =
  | "createNew"
  | "exportRecipes"
  | "importRecipes"
  | "importIngredients"
  | "shareRecipes"
  | "createRecipe"
  | "createMenuItemRecipe"
  | "createMenuItem"
  | "createPrepRecipe"
  | "createMaterial"
  | "changeToDraft"
  | "deleteSelected";

export function useRecipeDialogs() {
  const [openDialog, setOpenDialog] = useState<RecipeDialogId | null>(null);

  const open = useCallback((id: RecipeDialogId) => setOpenDialog(id), []);
  const close = useCallback(() => setOpenDialog(null), []);

  const isOpen = useCallback(
    (id: RecipeDialogId) => openDialog === id,
    [openDialog],
  );

  const setDialogOpen = useCallback(
    (id: RecipeDialogId) => (value: boolean) => {
      if (value) {
        setOpenDialog(id);
      } else {
        setOpenDialog(null);
      }
    },
    [],
  );

  return {
    openDialog,
    open,
    close,
    isOpen,
    setDialogOpen,
  };
}
